import { Spacer } from "@/components/spacer"
import { FaqSection } from "@/sections/Faq"
import { Benefits } from "@/sections/benefits"
import { Customers } from "@/sections/customers"
import { FinalCta } from "@/sections/final-cta"
import { Hero } from "@/sections/hero"
import { HowItWorks } from "@/sections/how-it-works"
import { UseCases } from "@/sections/use-cases"
import React, { FC } from "react"

interface EcommerceTemplateProps {
  data: any
}

export const EcommerceTemplate: FC<EcommerceTemplateProps> = (props) => {
  const { data } = props

  if (!data) {
    return null
  }

  const mainHero = data.hero
  const useCasesData = data.useCases
  const howItWorksData = data.howItWorks
  const customersData = data.customers
  const benefitsData = data.benefits
  const faqData = data.faq
  const finalCtaData = data.finalCta

  return (
    <>
      <Spacer height={{ default: "71px" }} />
      <Hero data={mainHero} />
      <Spacer height={{ default: "120px", md: "177px" }} />
      <UseCases data={useCasesData} />
      <Spacer height={{ default: "80px", md: "120px" }} />
      <HowItWorks data={howItWorksData} />
      <Spacer height={{ default: "110px", md: "90px" }} />
      <Customers data={customersData} />
      <Spacer height={{ default: "95px", md: "84px" }} />
      <Benefits data={benefitsData} />
      <Spacer height={{ default: "14px", md: "82px" }} />
      <FaqSection data={faqData} />
      <Spacer height={{ default: "138px", md: "200px" }} />
      <FinalCta data={finalCtaData} />
      <Spacer height={{ default: "44px", md: "27px" }} />
    </>
  )
}
